module.exports = __webpack_public_path__ + "img/sbg.65919a5b.jpg";